// Copyright (c) 2020 Deere & Company

import actions from '../../actions-list';
import {getDefaultState} from '../state';

const updatePart = (state, action) => action.part;

const resetPart = () => getDefaultState().pin;

export default (state = getDefaultState().part, action) => {

    const actionTypes = {
        [actions.UPDATE_PART_COVERAGE_SEARCH_PART_DETAILS_SUCCESS]: updatePart,
        [actions.RESET_PART_COVERAGE_SEARCH_REPORT]: resetPart,
        [actions.RESET_PART_COVERAGE_SEARCH_ADDITIONAL_INFORMATION]: resetPart
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};




// WEBPACK FOOTER //
// ./src/reports/parts-coverage-search/reducers/part.js